export default __webpack_public_path__ + "static/cooking-presentation-24b90baf5b89130570a5202bf3388418.png";